import { StylesObject } from '../../types/styles'
import { SITE_VARIABLES, mq } from '../../themes/variables'

export interface GradeStylesObject extends StylesObject {
    root: StylesObject
    imageWrapper: StylesObject
    image: StylesObject
    headerWrapper: StylesObject
    center: StylesObject
    header: StylesObject
    subText: StylesObject
    content: StylesObject
    divider: StylesObject
    iconWrapper: StylesObject
}

export const getDefaultGradeStylesObj = (
    siteVars: typeof SITE_VARIABLES,
    preview: boolean | undefined,
): GradeStylesObject => {
    const { COLORS, TEXT_FONT_FAMILY, FONT_SIZE } = siteVars

    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            margin: '1.5rem 0',
            paddingTop: '1rem',
            borderTop: `0.25rem solid ${COLORS.GRAY}`,
            ...(!preview && {
                [mq[2]]: {
                    margin: '2rem 0',
                    textAlign: 'left',
                },
            }),
        },
        imageWrapper: {
            display: 'flex',
            flex: '0 0 3.5rem',
            marginRight: '1rem',
        },
        image: {
            width: '3.5rem',
            height: '3.5rem',
            borderRadius: '50%',
        },
        headerWrapper: {
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            flex: '1 1 auto',
        },
        center: {
            textAlign: 'center',
            ...(!preview && {
                [mq[2]]: {
                    textAlign: 'left',
                },
            }),
        },
        header: {
            ...FONT_SIZE.H1,
            margin: '0',
            color: COLORS.DARK,
        },
        subText: {
            ...FONT_SIZE.H3,
            fontWeight: '800',
            lineHeight: '1.2',
            marginTop: '0.2rem',
            color: COLORS.DARKGRAY,
        },
        content: {
            paddingBottom: '1rem',
            color: COLORS.MEDIUMGRAY,
            borderBottom: `0.25rem solid ${COLORS.GRAY}`,
        },
        divider: {
            fontWeight: '400',
        },
        iconWrapper: {
            fontFamily: TEXT_FONT_FAMILY.DEFAULT,
            fontSize: '1.2rem',
            fontWeight: '800',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            flex: '0 0 3.5rem',
            justifyContent: 'center',
            width: '3.5rem',
            height: '3.5rem',
            marginLeft: '1rem',
            color: COLORS.WHITE,
            backgroundSize: 'cover',
            '& *': {
                position: 'absolute',
            },
        },
    }
}
